module.exports = __webpack_public_path__ + "static/media/accountView.11def537.png";